// src/Store/Slice/createProjectSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  firstLevelCategory: "",
  secondLevelCategory: "",
  thirdLevelCategory: "",
  answers: [], // { questionId: string, answer: any }
  price: null,
  time: null,
  selectedAddress: null, // store full address object or ID
};

const createProjectSlice = createSlice({
  name: "createProjectSlice",
  initialState,
  reducers: {
    setCategoryValue(state, action) {
      if (action.payload.step === "firstCategory") {
        state.firstLevelCategory = action.payload.firstLevelCategory;
        state.secondLevelCategory = "";
        state.thirdLevelCategory = "";
        state.answers = [];
        state.price = null;
        state.time = null;
        state.selectedAddress = null;
      }
      if (action.payload.step === "secondCategory") {
        state.secondLevelCategory = action.payload.secondLevelCategory;
        state.thirdLevelCategory = "";
        state.answers = [];
        state.price = null;
        state.time = null;
        state.selectedAddress = null;
      }
      if (action.payload.step === "thirdCategory") {
        state.thirdLevelCategory = action.payload.thirdLevelCategory;
        state.answers = [];
        state.price = null;
        state.time = null;
        state.selectedAddress = null;
      }
    },

    setStepBack(state, action) {
      if (action.payload.step === "firstCategory") {
        state.firstLevelCategory = "";
        state.secondLevelCategory = "";
        state.thirdLevelCategory = "";
        state.answers = [];
        state.price = null;
        state.time = null;
        state.selectedAddress = null;
      }
      if (action.payload.step === "secondCategory") {
        state.secondLevelCategory = "";
        state.thirdLevelCategory = "";
        state.answers = [];
        state.price = null;
        state.time = null;
        state.selectedAddress = null;
      }
      if (action.payload.step === "thirdCategory") {
        state.thirdLevelCategory = "";
        state.answers = [];
        state.price = null;
        state.time = null;
        state.selectedAddress = null;
      }
    },

    setAnswer(state, action) {
      const { questionId, answer } = action.payload;
      const existingIndex = state.answers.findIndex(
        (a) => a.questionId === questionId,
      );
      if (existingIndex !== -1) {
        state.answers[existingIndex].answer = answer;
      } else {
        state.answers.push({ questionId, answer });
      }
    },

    clearAnswers(state) {
      state.answers = [];
    },

    setPriceAndTime(state, action) {
      state.price = action.payload.price;
      state.time = action.payload.time;
    },

    setSelectedAddress(state, action) {
      state.selectedAddress = action.payload; // store full address object
    },
    clearAllProjectData(state, action) {
      state.firstLevelCategory = "";
      state.secondLevelCategory = "";
      state.thirdLevelCategory = "";
      state.answers = []; // { questionId: string, answer: any }
      state.price = null;
      state.time = null;
      state.selectedAddress = null;
      // store full address object
    },
  },
});

export const {
  setCategoryValue,
  setStepBack,
  setAnswer,
  clearAnswers,
  setPriceAndTime,
  setSelectedAddress,
  clearAllProjectData,
} = createProjectSlice.actions;
export default createProjectSlice.reducer;
